import "./enturf.css";
import Stack from "@mui/material/Stack";
import Overview from '../../../assets/Overview.svg'
import Home from '../../../assets/Home.svg'

function Enturf() {
  return (
    <>
      <div className="container-fluid EnTurf mt-5">
        <div className="cnt_2 mt-5">
          <div className="row mt-5">
            <div className="col-xl-6 col-md-6  d-flex justify-content-center">
              <div className="cnt2_tit">
                <h1 className="cnt2_txt">
                  Why <span className="En">En</span>turf ?
                </h1>
                <p className="cnt2_defn mt-5">
                 Book through Enturf in our Enhanced turfs<br></br>and relive the experience,analyse and share<br></br> your video with friends and community<br></br> members.
                </p>
                <br></br>
              </div>
            </div>
            <div className="col-xl-6  col-md-6  d-flex justify-content-center">
              <div className="overview">
                <Stack direction="row" spacing={4}>
                  <img
                    src={Overview}
                    alt="over"
                    className="over img-fluid"
                  ></img>
                  <img
                    src={Home}
                    alt="home"
                    className="home img-fluid"
                  ></img>
                </Stack>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Enturf;
